export default {
  title: {
    nl: 'Log in om een avatar te maken'
  },

  text: {
    nl: 'Als je een avatar wilt maken, moet je eerst even inloggen!'
  },

  button: {
    nl: 'Log in'
  }
};
